/* global window, document, fetch, FormData, CustomEvent */
/* ORIMODO storefront bridge. Load this asset from the Shopify theme layout. */
(function () {
  "use strict";

  var proxyBase = "/apps/orimodo";
  var sessionState = null;

  function idempotencyKey() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") return window.crypto.randomUUID();
    return "orimodo-" + Date.now() + "-" + Math.random().toString(16).slice(2);
  }

  function login() {
    var returnUrl = window.location.pathname + window.location.search + window.location.hash;
    window.location.assign("/account/login?return_url=" + encodeURIComponent(returnUrl));
  }

  function request(path, options, authenticationMode) {
    var settings = Object.assign({ credentials: "same-origin" }, options || {});
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
    settings.signal = controller.signal;
    if (!(settings.body instanceof FormData)) {
      settings.headers = Object.assign({ "Content-Type": "application/json" }, settings.headers || {});
    }
    return fetch(proxyBase + path, settings).then(function (response) {
      if (response.status === 401) {
        if (authenticationMode !== "silent") login();
        return Promise.reject(new Error("AUTH_REQUIRED"));
      }
      return response.json().then(function (body) {
        if (!response.ok) throw new Error(body.code || "ORIMODO_REQUEST_FAILED");
        return body;
      });
    }).finally(function () { window.clearTimeout(timeout); });
  }

  function purchaseStatus(message) {
    document.querySelectorAll("[data-orimodo-purchase-status]").forEach(function (node) {
      node.textContent = message;
      node.hidden = !message;
    });
  }

  function setButtonState(button, enabled, label) {
    if (!button) return;
    button.disabled = !enabled;
    if (label) button.textContent = label;
    button.setAttribute("aria-disabled", String(!enabled));
  }

  function activeIssue() {
    return sessionState && sessionState.activeIssue;
  }

  function applySession(data) {
    sessionState = data;
    var issue = activeIssue();
    document.querySelectorAll("[data-orimodo-buy-now]").forEach(function (button) {
      var productId = button.closest("[data-orimodo-purchase-controls]")?.dataset.productId;
      var matchesProduct = !productId || !issue || String(issue.shopifyProductId).endsWith("/" + productId);
      var enabled = Boolean(data.permissions && data.permissions.canBuy && issue && matchesProduct);
      setButtonState(button, enabled, enabled ? button.dataset.readyLabel : (issue ? button.dataset.soldOutLabel : button.dataset.closedLabel));
    });
    document.querySelectorAll("[data-orimodo-member-buy]").forEach(function (button) {
      var isMember = Boolean(data.membership);
      if (button.closest('[data-membership-only]') && isMember) {
        setButtonState(button, false, "Your membership is active");
        return;
      }
      var reservingMembership = !isMember;
      var productId = button.closest("[data-orimodo-purchase-controls]")?.dataset.productId;
      var matchesProduct = !productId || !issue || String(issue.shopifyProductId).endsWith("/" + productId);
      var enabled = reservingMembership
        ? Boolean(data.permissions && data.permissions.canReserveMembership)
        : Boolean(data.permissions && data.permissions.canMemberBuy && issue && matchesProduct);
      var completed = issue && issue.memberEntitlementStatus === "PAID";
      var enabledLabel = reservingMembership
        ? (button.dataset.reserveLabel || "Reserve your place")
        : button.dataset.readyLabel;
      setButtonState(button, !completed && enabled, completed ? button.dataset.completedLabel : (enabled ? enabledLabel : button.dataset.waitingLabel));
    });
    document.querySelectorAll("[data-orimodo-member-rank]").forEach(function (node) {
      node.textContent = data.membership && data.membership.rank ? String(data.membership.rank) : (node.dataset.emptyLabel || "");
    });
    document.querySelectorAll("[data-orimodo-purchase-status]").forEach(function (node) {
      node.textContent = node.closest('[data-membership-only]') ? "" : (issue ? (issue.explanation || "") : "The next collection is not available yet.");
      node.hidden = !node.textContent;
    });
  }

  function applyAnonymousState() {
    document.querySelectorAll("[data-orimodo-buy-now]").forEach(function (button) {
      var available = button.closest("[data-orimodo-purchase-controls]")?.dataset.productAvailable === "true";
      setButtonState(button, available, available ? button.dataset.readyLabel : button.dataset.closedLabel);
    });
    document.querySelectorAll("[data-orimodo-member-buy]").forEach(function (button) {
      setButtonState(button, true, button.dataset.reserveLabel || "Reserve your place");
    });
  }

  function loadSession() {
    return request("/session", undefined, "silent").then(applySession).catch(function (error) {
      if (error.message === "AUTH_REQUIRED") applyAnonymousState();
      else purchaseStatus("Purchase options could not load. Please refresh the page or contact studio@orimodo.com.");
      throw error;
    });
  }

  function buy(button, member) {
    var issue = activeIssue();
    button.disabled = true;
    if (member && !(sessionState && sessionState.membership)) {
      request("/membership-checkout", {
        method: "POST",
        body: JSON.stringify({ idempotencyKey: idempotencyKey() })
      }).then(function (result) {
        if (!result.checkoutUrl) throw new Error("CHECKOUT_UNAVAILABLE");
        window.location.assign(result.checkoutUrl);
      }).catch(function (error) {
        button.disabled = false;
        if (error.message !== "AUTH_REQUIRED") purchaseStatus("We could not open checkout. Please try again or contact studio@orimodo.com.");
      });
      return;
    }
    if (!issue) {
      button.disabled = false;
      return;
    }
    var payload = { issueId: issue.id, variantId: issue.shopifyVariantId, idempotencyKey: idempotencyKey() };
    if (!member) payload.quantity = Math.max(1, Number(button.dataset.quantity || 1));
    request(member ? "/member-checkout" : "/buy-now", { method: "POST", body: JSON.stringify(payload) }).then(function (result) {
      if (!result.checkoutUrl) throw new Error("CHECKOUT_UNAVAILABLE");
      window.location.assign(result.checkoutUrl);
    }).catch(function (error) {
      button.disabled = false;
      if (error.message !== "AUTH_REQUIRED") purchaseStatus("We could not open checkout. Please try again or contact studio@orimodo.com.");
    });
  }

  function bindPurchases() {
    document.querySelectorAll("[data-orimodo-buy-now]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!sessionState) {
          login();
          return;
        }
        if (!button.disabled) buy(button, false);
      });
    });
    document.querySelectorAll("[data-orimodo-member-buy]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!sessionState) {
          login();
          return;
        }
        if (!button.disabled) buy(button, true);
      });
    });
  }

  function setSubmissionStatus(form, text) {
    var status = form.querySelector("[data-orimodo-submission-status]");
    if (!status) return;
    status.textContent = text || "";
    status.hidden = !text;
  }

  function bindDiary() {
    document.querySelectorAll("[data-orimodo-diary-form], [data-orimodo-submission-form]").forEach(function (form) {
      if (form.dataset.orimodoBound === "true") return;
      form.dataset.orimodoBound = "true";
      var submitButton = form.querySelector("[data-orimodo-submission-submit], button[type='submit']");

      function submit(event) {
        event.preventDefault();
        if (!form.reportValidity()) return;
        var file = form.querySelector('input[name="image"]')?.files[0];
        var inspiration = form.querySelector('[name="inspiration"]')?.value.trim();
        if (!file) {
          setSubmissionStatus(form, "Choose a photo before submitting.");
          return;
        }
        if (file && (!["image/jpeg", "image/png", "image/webp"].includes(file.type) || file.size > 20 * 1024 * 1024)) {
          setSubmissionStatus(form, "Choose a JPG, PNG or WEBP image up to 20 MB.");
          return;
        }
        if (!inspiration) {
          setSubmissionStatus(form, "Add a few words about your photo before submitting.");
          return;
        }
        var data = new FormData(form);
        if (submitButton) submitButton.disabled = true;
        setSubmissionStatus(form, "");
        request("/diary", { method: "POST", body: data }).then(function () {
          form.dispatchEvent(new CustomEvent("orimodo:submitted", { bubbles: true }));
          setSubmissionStatus(form, form.dataset.successText || "Submitted");
          form.reset();
        }).catch(function (error) {
          var messages = {
            IMAGE_REQUIRED: "Choose a photo before submitting.",
            IMAGE_TYPE_INVALID: "Choose a JPG, PNG or WEBP image up to 20 MB.",
            IMAGE_TOO_LARGE: "Choose a JPG, PNG or WEBP image up to 20 MB.",
            INSPIRATION_REQUIRED: "Add a few words about your photo before submitting.",
            AUTH_REQUIRED: "Please sign in to submit your photo."
          };
          setSubmissionStatus(form, messages[error.message] || "Your submission could not be sent. Please try again. Your photo and text are still here.");
        }).finally(function () {
          if (submitButton) submitButton.disabled = false;
        });
      }

      form.addEventListener("submit", submit);
      if (submitButton && submitButton.type !== "submit") submitButton.addEventListener("click", submit);
    });
  }

  function renderFeatured(container, items) {
    var target = container.querySelector(".orimodo-story__diary-grid") || container;
    if (container.hasAttribute("data-hide-when-empty")) container.hidden = !items.length;
    target.replaceChildren();
    var diaryUrl = container.dataset.diaryUrl || "/pages/inspiration-diary";
    items.forEach(function (item) {
      var article = document.createElement("article");
      article.className = "orimodo-story__diary-entry";
      var link = document.createElement("a");
      link.href = diaryUrl;
      link.className = "orimodo-story__diary-entry-link";
      link.dataset.diaryId = item.id;
      var image = document.createElement("img");
      image.src = item.imageUrl;
      image.alt = item.title || "";
      image.className = "orimodo-story__diary-entry-image";
      image.loading = "lazy";
      link.appendChild(image);
      var title = String(item.title || '').trim();
      var body = container.dataset.showBody === "true" ? String(item.inspirationText || '').trim() : '';
      if (title || body) {
        var captionPanel = document.createElement("div");
        captionPanel.className = "orimodo-story__diary-caption";
        if (title) {
        var caption = document.createElement("p");
        caption.className = "orimodo-story__diary-entry-caption";
        caption.textContent = title;
        captionPanel.appendChild(caption);
        }
        if (body) captionPanel.appendChild(myElement("p", "orimodo-story__diary-entry-caption", body));
        link.appendChild(captionPanel);
      }
      article.appendChild(link);
      target.appendChild(article);
    });
  }

  function loadFeatured() {
    document.querySelectorAll("[data-orimodo-featured]").forEach(function (container) {
      var device = window.matchMedia("(max-width: 749px)").matches ? "mobile" : "desktop";
      request("/featured?device=" + device + "&seed=" + encodeURIComponent(String(Date.now()))).then(function (result) { renderFeatured(container, result.items || []); }).catch(function () {});
    });
  }

  function myElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = String(text);
    return element;
  }

  function myValue(label, value, attribute) {
    var row = myElement("div", "orimodo-my__value");
    row.appendChild(myElement("span", "orimodo-my__label", label));
    var content = myElement("strong", "orimodo-my__value-text", value || "-");
    if (attribute) content.setAttribute(attribute, "");
    row.appendChild(content);
    return row;
  }

  function renderMy(container, data) {
    var labels = container.dataset;
    container.replaceChildren();
    container.classList.add("orimodo-my");

    var identity = myElement("header", "orimodo-my__identity");
    identity.appendChild(myElement("p", "orimodo-my__eyebrow", labels.eyebrow || "MY"));
    var email = myElement("h1", "orimodo-my__email", data.customer && data.customer.email ? data.customer.email : "-");
    email.setAttribute("data-orimodo-my-email", "");
    identity.appendChild(email);
    container.appendChild(identity);

    var membership = myElement("section", "orimodo-my__section orimodo-my__membership");
    membership.appendChild(myElement("h2", "orimodo-my__heading", labels.membershipLabel || "Membership"));
    if (data.membership) {
      membership.appendChild(myValue(labels.statusLabel || "Status", data.membership.status));
      membership.appendChild(myValue(labels.numberLabel || "Member number", data.membership.number, "data-orimodo-my-member-number"));
      membership.appendChild(myValue(labels.rankLabel || "Priority rank", data.membership.rank, "data-orimodo-my-member-rank"));
      if (data.membership.status === "ACTIVE") {
        membership.appendChild(refundForm("Leave membership and request deposit refund", { membershipId: data.membership.id }));
      }
    } else {
      membership.appendChild(myElement("p", "orimodo-my__empty", labels.noMembershipLabel || "No active membership"));
    }
    container.appendChild(membership);

    var release = myElement("section", "orimodo-my__section");
    release.hidden = true;
    container.appendChild(release);
    request("/session", undefined, "silent").then(function (session) {
      sessionState = session;
      var issue = session.activeIssue;
      if (!issue) return;
      release.hidden = false;
      release.appendChild(myElement("h2", "orimodo-my__heading", issue.title || "Current collection"));
      var status = myElement("p", "orimodo-my__meta", issue.explanation || "");
      status.setAttribute("data-orimodo-purchase-status", "");
      release.appendChild(status);
      var member = Boolean(session.permissions && session.permissions.canMemberBuy);
      if (member || (session.permissions && session.permissions.canBuy)) {
        var label = issue.memberEntitlementStatus === "CHECKOUT_CREATED" ? "Continue checkout" : (member ? "Member purchase" : "Buy now");
        var purchase = myElement("button", "button", label);
        purchase.type = "button";
        purchase.addEventListener("click", function () { if (!purchase.disabled) buy(purchase, member); });
        release.appendChild(purchase);
      } else if (issue.memberEntitlementStatus === "PAID") {
        status.textContent = "Your purchase is complete.";
      }
    }).catch(function () {
      release.hidden = false;
      release.appendChild(myElement("p", "orimodo-my__meta", "Collection access could not load. Please refresh to try again."));
    });

    var orders = myElement("section", "orimodo-my__section orimodo-my__orders");
    orders.appendChild(myElement("h2", "orimodo-my__heading", labels.ordersLabel || "Orders"));
    (data.orders || []).forEach(function (order) {
      var item = myElement("article", "orimodo-my__order");
      item.setAttribute("data-orimodo-my-order", "");
      if (order.imageUrl) {
        var image = document.createElement("img");
        image.src = order.imageUrl;
        image.alt = order.issueTitle || "Order";
        image.loading = "lazy";
        item.appendChild(image);
      }
      var orderText = myElement("div", "orimodo-my__order-text");
      orderText.appendChild(myElement("h3", "orimodo-my__item-title", order.issueTitle || order.orderId));
      orderText.appendChild(myElement("p", "orimodo-my__meta", order.fulfillmentStatus || "Processing"));
      if (order.fulfillmentStatus !== "REFUNDED") orderText.appendChild(refundForm("Request an order refund", { orderId: order.orderId }));
      item.appendChild(orderText);
      orders.appendChild(item);
    });
    if (!(data.orders || []).length) orders.appendChild(myElement("p", "orimodo-my__empty", labels.noOrdersLabel || "No orders yet"));
    container.appendChild(orders);

    var diary = myElement("section", "orimodo-my__section orimodo-my__diary");
    diary.setAttribute("data-orimodo-my-diary", "");
    diary.appendChild(myElement("h2", "orimodo-my__heading", labels.diaryLabel || "Inspiration diary"));
    var diaryGrid = myElement("div", "orimodo-my__diary-grid");
    (data.diary || []).forEach(function (entry) {
      var item = myElement("article", "orimodo-my__diary-item");
      item.setAttribute("data-featured", String(Boolean(entry.featured)));
      var image = document.createElement("img");
      image.src = entry.imageUrl;
      image.alt = entry.title || "Inspiration diary";
      image.loading = "lazy";
      item.appendChild(image);
      if (entry.featured) item.appendChild(myElement("span", "orimodo-my__featured", labels.featuredLabel || "Official selection"));
      item.appendChild(myElement("h3", "orimodo-my__item-title", entry.title));
      item.appendChild(myElement("p", "orimodo-my__meta", entry.status));
      diaryGrid.appendChild(item);
    });
    diary.appendChild(diaryGrid);
    if (!(data.diary || []).length) diary.appendChild(myElement("p", "orimodo-my__empty", labels.noDiaryLabel || "No diary entries yet"));
    container.appendChild(diary);
    if ((data.refunds || []).length) {
      var refunds = myElement("section", "orimodo-my__section");
      refunds.appendChild(myElement("h2", "orimodo-my__heading", "Refund requests"));
      (data.refunds || []).forEach(function (refund) {
        refunds.appendChild(myElement("p", "orimodo-my__meta", refund.status + " — " + refund.reason));
      });
      container.appendChild(refunds);
    }
    var membershipLink = myElement("a", "orimodo-my__help", "Membership details and refund requests");
    membershipLink.href = "/pages/membership";
    container.appendChild(membershipLink);
  }

  function refundForm(title, target) {
    var details = myElement("details", "orimodo-my__action");
    details.appendChild(myElement("summary", "", title));
    var form = myElement("form", "orimodo-my__form");
    var label = myElement("label", "", "Reason");
    var reason = document.createElement("textarea");
    reason.name = "reason";
    reason.required = true;
    reason.maxLength = 2000;
    reason.rows = 3;
    label.appendChild(reason);
    form.appendChild(label);
    var submit = myElement("button", "button", "Submit request");
    submit.type = "submit";
    form.appendChild(submit);
    var status = myElement("p", "orimodo-my__meta");
    status.setAttribute("role", "status");
    form.appendChild(status);
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!form.reportValidity() || !reason.value.trim() || submit.disabled) return;
      submit.disabled = true;
      status.textContent = "Submitting…";
      request("/refund-requests", { method: "POST", body: JSON.stringify(Object.assign({}, target, { reason: reason.value.trim() })) }).then(function () {
        status.textContent = "Your request has been received. You can check its status here after refreshing. Refunds are processed after review.";
        reason.readOnly = true;
        submit.textContent = "Request submitted";
      }).catch(function (error) {
        submit.disabled = false;
        status.textContent = error.message === "AUTH_REQUIRED" ? "Please sign in to submit your request." : "Your request could not be sent. Please try again.";
      });
    });
    details.appendChild(form);
    return details;
  }

  function loadMy() {
    document.querySelectorAll("[data-orimodo-my]").forEach(function (container) {
      request("/my").then(function (data) {
        renderMy(container, data);
        container.dispatchEvent(new CustomEvent("orimodo:my-loaded", { bubbles: true, detail: data }));
      }).catch(function (error) {
        if (error.message === "AUTH_REQUIRED") return;
        container.replaceChildren(myElement("p", "orimodo-my__empty", "Your account could not load. Please try again."));
        var retry = myElement("button", "button", "Try again");
        retry.type = "button";
        retry.addEventListener("click", function () { retry.disabled = true; loadMy(); });
        container.appendChild(retry);
      });
    });
  }

  function boot() {
    bindPurchases();
    bindDiary();
    loadFeatured();
    window.setInterval(loadFeatured, 10000);
    if (document.querySelector("[data-orimodo-my]")) {
      loadMy();
    } else if (document.querySelector("[data-orimodo-buy-now], [data-orimodo-member-buy], [data-orimodo-member-rank], [data-orimodo-diary-form], [data-orimodo-submission-form]")) {
      loadSession().catch(function () {});
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
}());
